import { useSelector } from "react-redux";
import { FeatureName } from "./FeatureName";
import { getFeatureSelector } from "./getFeatureSelector";

export const useFeatureOn = (featureName: FeatureName) => {
  return useSelector(getFeatureSelector(featureName));
};
